import type { Patrol } from '@local/common-lib';
import { Chip, Stack } from '@mui/material';
import type { FC } from 'react';

type Status = {
  color: 'default' | 'error' | 'info' | 'success' | 'warning';
  label: string;
};

export const patrolStatuses = (
  patrol: Patrol.Type,
  options?: { hideUnstartedBadge?: boolean },
): Status[] => {
  if (patrol.cancelled) return [{ color: 'error', label: 'CANCELLED' }];
  if (!patrol.finalized) return [{ color: 'warning', label: 'DRAFT' }];

  if (patrol.finished) {
    const statuses: Status[] = [{ color: 'success', label: 'COMPLETED' }];
    if (patrol.finished.administrative) {
      statuses.push({ color: 'info', label: 'ADMIN' });
    }
    return statuses;
  }

  if (patrol.started) return [{ color: 'info', label: 'IN PROGRESS' }];

  if (options?.hideUnstartedBadge) return [];

  const finish = patrol.when.getTime() + patrol.hours * 60 * 60 * 1000;
  if (finish < Date.now()) {
    return [{ color: 'warning', label: 'NOT STARTED' }];
  }

  return [];
};

export const PatrolStatusChips: FC<{
  hideUnstartedBadge?: boolean;
  patrol: Patrol.Type;
}> = ({ hideUnstartedBadge, patrol }) => {
  const statuses = patrolStatuses(patrol, { hideUnstartedBadge });
  if (!statuses.length) return null;

  return (
    <Stack direction="row" spacing={0.5} sx={{ flexWrap: 'wrap', mt: 0.5 }}>
      {statuses.map((status) => (
        <Chip
          color={status.color}
          key={status.label}
          label={status.label}
          size="small"
        />
      ))}
    </Stack>
  );
};
